import React, {} from 'react';

import { ReactComponent as PDFFileIcon } from 'assets/images/pdf-file-icon.svg';
import { ReactComponent as TextFileIcon } from 'assets/images/text-file-icon.svg';
import { ReactComponent as CSVFileIcon } from 'assets/images/csv-file-icon.svg';
import { ReactComponent as WordFileIcon } from 'assets/images/word-file-icon.svg';
import { ReactComponent as SpreadsheetFileIcon } from 'assets/images/spreadsheet-file-icon.svg';
import { ReactComponent as UnknownFileIcon } from 'assets/images/unknown-file-icon.svg';

import './index.scss';

function DocumentDisplay(props) {

  function renderMain() {

    const file = props.file;

    function renderFileTypeIcon() {

      const mimetype = file.mimetype;

      if (mimetype === 'application/pdf') {
        return <PDFFileIcon />;
      }

      if (mimetype === 'text/csv') {
        return <CSVFileIcon />;
      }

      if (mimetype === 'text/plain') {
        return <TextFileIcon />;
      }

      const wordFileTypes = [
        'application/msword',
        'application/vnd.openxmlformats',
        'officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      ];

      if (wordFileTypes.indexOf(mimetype) !== -1) {
        return <WordFileIcon />;
      }

      const spreadsheetFileTypes = [
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ];

      if (spreadsheetFileTypes.indexOf(mimetype) !== -1) {
        return <SpreadsheetFileIcon />;
      }

      return <UnknownFileIcon />;

    }

    function tryRenderUploadingProgressDetails() {

      if (props.uploading !== true) {
        return;
      }

      return <div className='uploading-progress-content'>
        <ht-spinner size="tiny" />
        <label className='uploading-label'>{props.uploadedPercent}</label>
      </div>;

    }

    function renderFileLink() {

      let fileName = file.name;

      if (fileName === void 0) {
        fileName = file.url;
      }

      const fileLinkAttributes = {
        href: file.url,
        target: '_blank',
        download: fileName
      };

      return <div className="document-file-link-section">

        <a {...fileLinkAttributes}>{fileName}</a>

        {tryRenderUploadingProgressDetails()}

      </div>;

    }

    return <div className="document-file-display-main">
      {renderFileTypeIcon()}
      {renderFileLink()}
    </div>;

  }

  return renderMain();

}

export default DocumentDisplay;